export default __webpack_public_path__ + "static/media/Facebook.4a76cb87.svg";